import { render, staticRenderFns } from "./PayerList.vue?vue&type=template&id=10dd989a&scoped=true&"
import script from "./PayerList.vue?vue&type=script&lang=js&"
export * from "./PayerList.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./PayerList.vue?vue&type=style&index=1&id=10dd989a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10dd989a",
  null
  
)

export default component.exports